import type { RouteParams, RouteRecordRaw } from "vue-router";
import {
    createRouter,
    createWebHistory,
} from "vue-router";

export type AppRouteNames = "admin" | "object" | "objects" | "file" | "asset";

const BASE_URL = __BASE_URL__;

export const routes: RouteRecordRaw[] = [
    {
        path: BASE_URL,
        redirect: { name: "objects" },
        children: [
            {
                name: "objects",
                path: String.raw`${BASE_URL}/object/`,
                components: {
                    default: () =>
                        import("@/app/components/table/ObjectTable.vue"),
                },
            },
            {
                path: String.raw`${BASE_URL}/not-implemented-yet/:text`,
                name: "empty",
                components: {
                    default: () => import("@/app/view/EmptyView.vue"),
                },
                props: true,
            },
        ],
    },
    {
        path: String.raw`${BASE_URL}/object/:object(\d+-\d+)`,
        component: () => import("@/app/view/HierarchyView.vue"),
        children: [
            {
                name: "object",
                path: String.raw`${BASE_URL}/object/:object(\d+-\d+)`,
                components: {
                    default: () =>
                        import("@/app/components/detail/ObjectDetail.vue"),
                },
                props: true,
            },
            {
                name: "model",
                path: String.raw`${BASE_URL}/object/:object(\d+-\d+)/model/:id(\d+)`,
                components: {
                    default: () =>
                        import("@/app/components/detail/ModelDetail.vue"),
                },
                props: true,
            },
            {
                name: "asset",
                path: String.raw`${BASE_URL}/object/:object(\d+-\d+)/asset/:id(\d+)`,
                components: {
                    default: () =>
                        import("@/app/components/detail/AssetDetail.vue"),
                },
                props: true,
            },
            {
                name: "file",
                path: String.raw`${BASE_URL}/object/:object(\d+-\d+)/file/:id(\d+)`,
                components: {
                    default: () =>
                        import("@/app/components/detail/FileDetail.vue"),
                },
                props: true,
            },
        ],
    },
    {
        path: BASE_URL + "/admin",
        redirect: { name: "admin" },
        component: () => import("@/app/view/AdminView.vue"),
        children: [
            {
                name: "admin",
                path: BASE_URL + "/admin/",
                components: {
                    default: () => import("@/app/admin/UserTable.vue"),
                },
            },
        ],
    },
];

export const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: "active",
});

export function routerPush(
    name: AppRouteNames,
    params?: RouteParams,
): ReturnType<typeof router.push> {
    return params === undefined
        ? router.push({ name })
        : router.push({ name, params });
}
